/**
 * ImageModal
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import clsx from 'clsx';
import React, { useState } from 'react';
import Modal from 'react-aria-modal';
import { Icon } from 'ui-component-library/base';
import Image from 'ui-component-library/base/Image';
/** Main description for this component. */
var ImageModal = function (_a) {
    var children = _a.children, openBtnLabel = _a.openBtnLabel, closeBtnLabel = _a.closeBtnLabel, className = _a.className;
    var _b = useState(false), modalActive = _b[0], setModalActive = _b[1];
    var _c = useState({
        src: '',
        alt: '',
    }), modalImage = _c[0], setModalImage = _c[1];
    var toggleModal = function (modalSrc, modalAlt) {
        setModalImage({
            alt: modalAlt || '',
            src: modalSrc || '',
        });
        setModalActive(!modalActive);
    };
    var renderChildren = function (children) {
        return React.Children.map(children, function (child, index) {
            var props = child && child.props ? __assign({}, child.props) : {};
            props.zoomIcon = true;
            props.toggleModal = toggleModal;
            props.openBtnLabel = openBtnLabel;
            return (React.createElement(React.Fragment, { key: index }, React.cloneElement(child, props || {})));
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-cid": "ImageModal", className: "relative" }, renderChildren(children)),
        modalActive && (React.createElement(Modal, { onExit: toggleModal, titleText: "Modal", underlayClickExits: true, focusDialog: true, verticallyCenter: true, underlayColor: "rgba(0,0,0,0.75)", underlayClass: "inset-0 flex justify-center items-center" },
            React.createElement("button", { "aria-label": closeBtnLabel, onClick: function (e) {
                    e.preventDefault();
                    toggleModal();
                }, className: "group absolute top-0 right-0 mt-4 mr-4" },
                React.createElement(Icon, { icon: "close", size: 4, className: "lg:w-14 lg:h-14 text-white" })),
            React.createElement("div", { className: "max-w-256" },
                React.createElement(Image, { loading: "lazy", src: modalImage.src, alt: modalImage.alt, className: clsx(modalImage.src.includes('.svg') && 'min-w-256') }))))));
};
export default ImageModal;
